export default __webpack_public_path__ + "static/media/australia.cca095af.svg";